module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isNavigationBar) ? _c('header', {
    staticClass: "row navigation-bar align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-6"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": _vm.aiLink
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ct_ai_logo.png",
      "alt": "app logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-6 text-right"
  }, [(!_vm.isParentUser && !_vm.isTeacherUser) ? _c('img', {
    staticClass: "licence-icon",
    attrs: {
      "src": ("/static/images/" + _vm.isActiveLicenceUser)
    },
    on: {
      "click": function($event) {
        return _vm.userLicence()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPrime) ? _c('img', {
    staticClass: "prime-icon",
    attrs: {
      "src": "/static/images/ic-prime-24.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navigation-dropdown",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "link",
      "no-caret": "",
      "right": true
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticClass: "user-profile",
    attrs: {
      "src": _vm.userProfileImage,
      "alt": "profile"
    }
  })]), _vm._v(" "), (!_vm.isParentUser && !_vm.isTeacherUser) ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.userBookmarkUrl()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.bookmark')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.userLanguageUrl()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.update_language')) + "\n        ")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.userProfileUrl()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.go_to_ct')) + "            \n        ")])], 2)], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-991c5f26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
// module id = 1601
// module chunks = 1